import { MdCloudCircle, MdSearch } from 'react-icons/md';
import { Heading, Icon, IconContainer } from '@nbirl/nbi-common-ui-libs';

type DocumentsListEmptyStateProps = { isSearching: boolean };

export const DocumentsListEmptyState: React.FC<DocumentsListEmptyStateProps> =
  ({ isSearching }) => (
    <div className="flex flex-col items-center space-y-2">
      {isSearching ? (
        <>
          <IconContainer variant="light">
            <Icon icon={<MdSearch className="text-primary-500" />} />
          </IconContainer>
          <p className="text-2xl font-medium">No matches found</p>
          <Heading className="text-center text-gray-700">
            There weren’t any documents matching your search.
          </Heading>
          <p className="text-center">Please try searching with another name.</p>
        </>
      ) : (
        <>
          <IconContainer variant="light">
            <Icon icon={<MdCloudCircle className="text-primary-500" />} />
          </IconContainer>
          <Heading className="text-center text-gray-700">
            No folders or documents added yet.
          </Heading>
          <p className="text-center">Please select upload document to begin.</p>
        </>
      )}
    </div>
  );
